import React, {useRef, useState} from "react";
import Table from "../Table/Table";
import {Col, Spinner} from "react-bootstrap";
import Dropdown, {components} from "react-select";
import {RiArrowDownSFill} from "react-icons/ri";
import {useEffect} from "react";
import {useContext} from "react";
import {store} from "../../Store/store";
import {getVmaLabelByUuid, snakeCaseToNormalString, updateControlUnitDetails, updateVmaItems} from "../../General/SharedMethods";
import {VALVES_LOW_CASE} from "../../Constants/constants";

export default function ValvesTable(
    {
        vmaDropdownOptions,
        connectivityStatusFormatter,
        nameFormatter,
        data,
        isUpdateDetailsRequestInProgress,
        isApplyingActive,
        updateVmaListArr,
        controlUnitDetails,
        vmaData,
        setControlUnitDetails,
        tableHeight
    }
) {
    const headerStyle = {minWidth: 100, fontSize: 14};
    const wideHeaderStyle = {minWidth: 200, fontSize: 14, paddingBottom: 15};
    const colStyle = {minWidth: 100, fontSize: 14, whiteSpace: 'nowrap', paddingTop: 15};
    const textColStyle = {maxWidth: 100, fontSize: 14, whiteSpace: 'nowrap', paddingTop: 10};
    const filtersRefs = useRef([]);
    const idFilterRef = useRef();
    const motorizedOpeningTimeFilterRef = useRef();
    const motorizedClosingTimeFilterRef = useRef();
    const timeBeforeTestingFilterRef = useRef();
    const vmaFilterRef = useRef();
    const [sortState, setSortState] = useState({dataField: 'order', order: 'asc'});

    useEffect(() => {

    }, [vmaDropdownOptions])

    const resetFilters = () => {
        filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        })
        idFilterRef.current?.resetFilter();
        motorizedOpeningTimeFilterRef.current?.resetFilter();
        motorizedClosingTimeFilterRef.current?.resetFilter();
        timeBeforeTestingFilterRef.current?.resetFilter();
        vmaFilterRef.current?.resetFilter();
    }

    const customDropdownStyles = {
        control: (provided, state) => ({
            fontSize: 14, ...provided
        }), option: (provided, state) => ({
            ...provided, fontSize: 14, minHeight: 40,
        })
    }

    const durationSecondsFormatter = (cell) => {
        return cell ? Math.round(cell / 1000) : 0;
    }

    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    const vmaDropDownFormatter = (cell, row) => {
        return (<VmaDropDown cell={cell} row={row} vmaDropdownOptions={vmaDropdownOptions}/>)
    }

    const onSort = (field, order) => {
        setSortState({dataField: field, order: order});
    }

    const columns =
        [
            {
                dataField: 'connectivityStatus',
                text: <div>Connectivity <br/> Status</div>,
                headerStyle: {width: 50, fontSize: 14},
                style: colStyle,
                formatter: connectivityStatusFormatter,
                editable: false
            },
            {
                dataField: 'waterSystem',
                text: 'Water System',
                headerStyle: wideHeaderStyle,
                formatter: nameFormatter,
                style: textColStyle,
                editable: false
            },
            {
                dataField: 'openingTime',
                text: <div>Opening<br/>Time [S]</div>,
                headerStyle: headerStyle,
                style: colStyle,
                editable: false,
                formatter: durationSecondsFormatter
            },
            {
                dataField: 'closingTime',
                text: <div>Closing<br/>Time [S]</div>,
                headerStyle: headerStyle,
                style: colStyle, editable: false,
                formatter: durationSecondsFormatter
            },
            {
                dataField: 'timeBeforeTesting',
                text: <div>Time Before<br/>Testing [S]</div>,
                headerStyle: headerStyle,
                style: colStyle,
                editable: false,
                formatter: durationSecondsFormatter
            },
            {
                dataField: 'vma',
                text: 'VMA',
                headerStyle: {minWidth: 200, fontSize: 14, paddingBottom: 15},
                formatter: vmaDropDownFormatter,
                editable: false
            },
            {
                dataField: 'role',
                text: 'Role',
                headerStyle: {minWidth: 100, fontSize: 14, paddingBottom: 15},
                style: {minWidth: 50, fontSize: 14, whiteSpace: 'nowrap', paddingTop: 15},
                formatter: snakeCaseToNormalString,
                editable: false
            },
        ]
    if (isUpdateDetailsRequestInProgress && !isApplyingActive) {
        return (<Col md={{offset: 5, span: 1}}><Spinner animation="border" variant="primary"/></Col>)
    } else {
        return (<div style={{overflowX: 'hidden', overflowY: 'auto', height: tableHeight}}>
            <Table
                isHeadersSticky={!tableHeight}
                data={data}
                columns={columns}
                disablePagination
                pageSize={15}
                resetFilters={resetFilters}
                defaultSort={sortState}
            />
        </div>)
    }

    function VmaDropDown({cell, row}) {
        const stateObj = useContext(store);
        const [previousValue, setPreviousValue] = useState({value: row.vma?.uuid, label: getVmaLabelByUuid(row.vma?.uuid, stateObj)});

        return (<Dropdown
            menuPosition={'fixed'}
            menuPortalTarget={document.body}
            styles={customDropdownStyles}
            options={stateObj.state.dropdownOptionsArr}
            defaultValue={previousValue}
            components={{
                IndicatorSeparator: () => null, DropdownIndicator
            }}
            onChange={(value) => {
                const updatedVmaList = updateVmaItems(value.value, row.uuid, previousValue, VALVES_LOW_CASE, stateObj);
                updateVmaListArr(updatedVmaList);
                updateControlUnitDetails(updatedVmaList, stateObj.state.cuDetails, vmaData, setControlUnitDetails, VALVES_LOW_CASE);
                setPreviousValue(value);
            }}
        />)
    }
}
